import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import 'tslib';
import '@popperjs/core';

var TabPanel = function (_a) {
    var _b = _a.activeTabId, activeTabId = _b === void 0 ? null : _b, addClassName = _a.addClassName, children = _a.children, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, forTabId = _a.forTabId, _c = _a.hideInactiveTabs, hideInactiveTabs = _c === void 0 ? false : _c;
    var active = activeTabId === null || activeTabId === forTabId;
    var className = classNames("tw-outline-none", addClassName, !active && "tw-hidden");
    if (!active && !hideInactiveTabs)
        return null;
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || "tab-panel", className: className, "aria-labelledby": forTabId, "aria-expanded": active, role: "tabpanel", tabIndex: active ? 0 : -1 }, children));
};

export { TabPanel };
//# sourceMappingURL=TabPanel.esm.js.map
